<template>

  <div>
    <v-dialog v-model="isDisplayed"
              :persistent="true"
              max-width="700px">
      <v-card>
        <p class="dialog-title">{{ dialogTitle }}</p>
        <v-card-text>
          <v-container fluid="fluid" grid-list-xl="grid-list-xl">

            <!-- MATCH ID -->
            <v-flex>
              <v-text-field v-model="editedVideo.matchID"
                            label="Match ID"
                            placeholder="Match ID"></v-text-field>
            </v-flex>

            <!-- TYPE -->
            <v-flex v-if="typeSelectorDisplayed">
              <v-select label="Type"
                        v-model="editedVideo.type"
                        :items="types"></v-select>
            </v-flex>

          </v-container>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>

          <!-- ERROR -->
          <v-flex>
            <v-spacer></v-spacer>
            <div class="error-message">{{ errorMessage }}</div>
          </v-flex>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

export default {
  name: 'Dialog',
  props: [
    'dialog',
    'dialogState',
    'currentEditedVideo',
    'errorMessage'
  ],
  data () {
    return {
      isDisplayed: false,

      editedVideo: {
        matchID: '',
        type: ''
      },

      types: ['point', 'wow', 'fail']
    }
  },
  mounted () {
    if (this.currentEditedVideo) {
      this.setCurrentEditedVideo()
    }
    if (this.dialog) {
      this.isDisplayed = true
    }
  },
  methods: {
    setCurrentEditedVideo () {
      this.editedVideo = {
        matchID: this.currentEditedVideo.matchID,
        type: this.currentEditedVideo.type
      }
    },

    save () {
      this.$emit('editVideo', this.editedVideo)
    },

    close () {
      this.clearData()
      this.isDisplayed = false
    },

    clearData () {
      this.editedVideo = {
        matchID: '',
        type: ''
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogButton + ' video'
    },

    dialogButton () {
      return this.dialogState.charAt(0).toUpperCase() + this.dialogState.slice(1)
    },
    typeSelectorDisplayed () {
      return this.currentEditedVideo && this.currentEditedVideo.type !== 'summary'
    }
  },
  watch: {
    'dialog' () {
      if (this.isDisplayed !== this.dialog) {
        this.isDisplayed = this.dialog
      }
    },
    'isDisplayed' () {
      if (!this.isDisplayed) {
        this.clearData()
        this.$emit('dialogClosed')
      }
    },
    'currentEditedVideo' () {
      if (this.currentEditedVideo) {
        this.setCurrentEditedVideo()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .dialog-title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
  }

  .error-message {
    color: red;
    text-align: end;
    font-weight: 700;
  }

</style>



// WEBPACK FOOTER //
// src/components/videos/Dialog.vue